import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
const model = (payload) => ({
  // columns
  id: payload.id,
  address_name: payload.address_name,
  street_name: payload.street_name,
  street_number: payload.street_number,
  city: payload.city,
  state: payload.state,
  country: payload.country,
  zip_code: payload.zip_code,
  customer_id: payload.customer_id
})
var crud = new Crud('CustomerAddresses', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  customerAddresses: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions,
  async loadAddresses ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`customers/${payload.customerId}/addresses?page=${payload.page}&customer_id=${payload.customerId}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_RECORDS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  customerAddresses: state => state.customerAddresses
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
